@switch (logo.type) {
    @case ('icon') {
        <svg cIcon
            name="logo"
            class="icon-custom-size"
            [class]="logo.cssClass"
            [title]="logo.name" />
    }
    @case ('image') {
        <img [src]="logo.value"
            [alt]="logo.name ?? 'logo'"
            [class]="logo.cssClass"
            loading="lazy" />
    }
}